export const environment = {
  production: true,
  sentryEnvironment: 'production',
  apiUrl: 'https://api.cohrex.ai/api/v1',
  cryptoSecretKey: import.meta.env['NG_APP_CRYPTO_SECRET_KEY'],
  appBaseUrl: 'https://app.cohrex.ai',
  enableSentry: true,
  sentryDSN: import.meta.env['NG_APP_SENTRY_DSN'],
  sentryReplaysSessionSampleRate: 1.0,
  supportEmail: 'support@cohrgroup.com',
  testToken: 'cohrex-test-token',
  newrelicLicenseKey: import.meta.env['NG_APP_NEW_RELIC_LICENSE_KEY'],
  newrelicAccountId: import.meta.env['NG_APP_NEW_RELIC_ACCOUNT_ID'],
  newrelicTrustKey: import.meta.env['NG_APP_NEW_RELIC_TRUST_KEY'],
  newrelicAgentId: import.meta.env['NG_APP_NEW_RELIC_AGENT_ID'],
  newrelicApplicationId: import.meta.env['NG_APP_NEW_RELIC_APPLICATION_ID']
};
